import { laptopLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import Image from '@propertypal/shared/src/resources/images/android-apple-header.png';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto -700px;
  padding: 105px 48px;

  @media screen and (${laptopLargeMax}) {
    margin-bottom: -620px;
    padding: 50px 50px 0 50px;
  }

  @media screen and (max-width: 1375px) {
    margin-bottom: -600px;
  }

  @media screen and (max-width: 1285px) {
    margin-bottom: -500px;
  }

  @media screen and (max-width: 1195px) {
    margin-bottom: -400px;
  }

  @media screen and (max-width: 1120px) {
    margin-bottom: 0;
    padding: 50px 0;
  }
`;

export const Boxes = styled.div`
  @media screen and (max-width: 1120px) {
    display: flex;
    padding-right: 30px;
    justify-content: center;
  }

  @media screen and (max-width: 850px) {
    flex-direction: column;
    align-items: center;
    padding: 0 15px;
  }
`;

export const MobileBoxes = styled.div`
  display: none;
  flex-direction: column;

  @media screen and (max-width: 1120px) {
    display: flex;
  }

  @media screen and (max-width: 850px) {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 15px;
  }
`;

export const BoxesRow = styled.div`
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 62px;

  @media screen and (max-width: 1195px) {
    margin-bottom: 40px;
  }

  @media screen and (max-width: 1120px) {
    display: none;
  }
`;

export const PhonesImage = styled.div`
  position: relative;
  background: url(${Image.src}) no-repeat bottom;
  background-size: contain;
  z-index: 99;
  height: 680px;
  margin: 0 auto;
  top: -670px;

  @media screen and (max-width: 1375px) {
    top: -650px;
    height: 630px;
  }

  @media screen and (max-width: 1285px) {
    top: -550px;
    height: 530px;
  }

  @media screen and (max-width: 1195px) {
    top: -440px;
    height: 420px;
  }

  @media screen and (max-width: 1120px) {
    display: none;
  }
`;

export const PhonesImageMobileBox = styled.div`
  display: none;

  @media screen and (max-width: 1120px) {
    display: block;
    width: 500px;
  }

  @media screen and (max-width: 850px) {
    width: 100%;
  }
`;

export const PhonesImageMobile = styled.div`
  position: relative;
  background: url(${Image.src}) no-repeat top;
  background-size: contain;
  height: 550px;

  @media screen and (max-width: 850px) {
    height: 350px;
    margin-bottom: 50px;
  }
`;

export const Box = styled.div`
  background: ${(props) => props.theme.backgroundLightest};
  width: 450px;
  height: 160px;
  padding-top: 29px;

  @media screen and (min-width: 1120px) {
    &:nth-child(1) {
      padding-right: 120px;
      padding-left: 25px;
    }
    &:nth-child(2) {
      padding-left: 120px;
      padding-right: 25px;
    }
  }

  @media screen and (max-width: 1120px) {
    padding: 20px;
    margin-bottom: 15px;
    height: 120px;
    width: 400px;

    h3 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 840px) {
    padding: 20px;
    width: calc(50% - 15px);
  }

  @media screen and (max-width: 640px) {
    width: 100%;
  }
`;
